var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-329 -8132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(329 8132)",
    fill: "#2db273",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M1512,45a15,15,0,1,1,10.606-4.393A14.9,14.9,0,0,1,1512,45Zm-7.608-15.293h0L1503,30.962l5.479,4.976,11.762-10.683L1518.858,24l-10.38,9.418-4.087-3.712Z",
    transform: "translate(-1152 8133)",
    fill: "#2db273"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.96a9c3e4208731345f3a6c17d88edbe4.svg";
export { ForwardRef as ReactComponent };